export const STORAGE = "handyman";

export const calculateMessageTime = (messageDate, t) => {
    const messageTime = new Date(messageDate).getTime();
    const currentTime = new Date().getTime();

    const secondsDiff = (currentTime - messageTime) / 1000; // Converts millisecond into seconds
    const minutesDiff = secondsDiff / 60;
    const hoursDiff = secondsDiff / 3600;
    const daysDiff = secondsDiff / 86400;

    if (daysDiff > 1)
      return `${t('sentAgo')} ${Math.floor(daysDiff)} ${
        daysDiff < 2 ? t('day') : t('days')
      }`;
    if (hoursDiff > 1)
      return `${t('sentAgo')} ${Math.floor(hoursDiff)} ${
        hoursDiff < 2 ? t('hour') : t('hours')
      }`;
    if (minutesDiff > 1)
      return `${t('sentAgo')} ${Math.floor(minutesDiff)} ${
        minutesDiff < 2 ? t('minute') : t('minutes')
      }`;
    if (secondsDiff > 1)
      return `${t('sentAgo')} ${Math.floor(secondsDiff)} ${
        secondsDiff < 2 ? t('second') : t('seconds')
      }`;
    return `${t('sentAgo')} ${t('justNow')}`;
  };